import * as types from "./mutation-types";

export default {
  [types.save_bonus](state: any, obj: any) {
    state.bonus = obj;
  },
};
